import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { ConsumerFundsState } from "../../models/mp-admin/consumer-funds-state";

const initialState: ConsumerFundsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpAdminActions.consumerFunds.getSuccess, (state, action) => _.omit(action, "type")),
	on(MpAdminActions.consumerFunds.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function consumerFundsReducer(
	state: ConsumerFundsState | undefined,
	action: Action
): ConsumerFundsState {
	return reducer(state, action);
}
